module.exports = __webpack_public_path__ + "img/foods.bd409e62.png";